// src/main/frontend/src/App.js

import { Route, Routes } from 'react-router-dom';
import Main from './common/Main'
import Main2 from './common/Main2'
import CompCulture from './user/CompanyInfo/Component/CompCulture'
import RecruitmentCard from './user/HumanResource/Component/RecruitmentCard'
import RecruitmentDetail from './user/HumanResource/Component/RecruitmentDetail'
import CEOInst from './user/CompanyInfo/Component/CEOInst'
import CompHistory from './user/CompanyInfo/Component/CompHistory'
import CompInfo from './user/CompanyInfo/Component/CompInfo'
import Vision from './user/CompanyInfo/Component/Vision'
import Location from './user/CompanyInfo/Component/Location'
import DetailItems from './user/Common/Component/DetailItems'
import FAQ from './user/HumanResource/Component/FAQ'
import Gallery from './user/PressCenter/Component/Gallery'
import CreatePost from './user/PressCenter/Component/CreatePost'
import News from './user/PressCenter/Component/News'
import CompanyMagazine from './user/PressCenter/Component/CompanyMagazine'
import CodeManagement from './admin/CodeManagement';
import Login from './admin/Login';
import Layout from "./common/Layout";
import CEOHistory from "./user/CompanyInfo/Component/CEOHistory"
import OrgChart from "./user/CompanyInfo/Component/OrgChart"
import Building from './user/BusinessInfo/Component/Building' //설계
import Develop from './user/BusinessInfo/Component/Develop'   //개발
import Quality from './user/BusinessInfo/Component/QualityINSP' //품질 검사
import JobIntroduction from './user/CompanyInfo/Component/JobIntroduction' //직무소개
import Personnel_System from './user/CompanyInfo/Component/Personnel_System' //인사제도
import CultivateHR from './user/HumanResource/Component/CultivateHR'
import ESGManagement from './user/CompanyInfo/Component/ESGManagement'
import Recruit from './admin/Recruit';
import HumanTest from './user/HumanResource/Component/HumanTest';
import RecruitInputs from './admin/RecruitInputs';
import Tetetest from './user/BusinessInfo/Component/tetetest' //scroll 테스트
import FileUpload from './common/FileUpload'
import { useEffect } from 'react';
//D:\SOTEC_Web\src\main\frontend\src\common\FileUpload.js

function App() {

    // let vh = 0;

    // useEffect(() => {
    //     vh = window.innerHeight * 0.01;
    //     document.documentElement.style.setProperty('--vh', `${vh}px`);
    // });

    // const setVh = () => {
    //     document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`)
    //     // console.log(document.documentElement.style.getPropertyValue('--vh'));
    // };
    //  window.addEventListener('resize', setVh);

    return (
        <Routes>
            <Route path="/" element={<Main2 />} />
            <Route path="/OrgChart" element={
                <Layout>
                    <OrgChart />
                </Layout>
            } />
            <Route path="/CompCulture" element={
                <Layout>
                    <CompCulture />
                </Layout>
            } />
            {/* <Route path="/Tetetest" element={
                <Layout>
                    <Tetetest />
                </Layout>
            } /> */}
            
            <Route path="/HumanTest" element={
                <Layout>
                    <HumanTest />
                </Layout>} />

            <Route path="/CompanyMagazine" element={
                <Layout>

                    <CompanyMagazine />
                </Layout>} />
            <Route path="/CompHistory" element={
                <Layout>

                    <CompHistory />
                </Layout>} />
            <Route path="/CreatePost" element={
                <Layout>
                    <CreatePost />
                </Layout>} />
            <Route path="/RecruitmentCard" element={
                <Layout>
                    <RecruitmentCard />
                </Layout>
            } />
            <Route path="/RecruitmentDetail" element={
                <Layout>
                    <RecruitmentDetail />
                </Layout>} />
            <Route path="/Recruit" element={
                <Layout>
                    <Recruit />
                </Layout>
            } />
            {/* <Route path="/Building2" element={
                <Layout>
                    <Building2 /> 
                </Layout>} /> */}
            <Route path="/CEOInst" element={
                <Layout>
                    <CEOInst />
                </Layout>
            } />

            <Route path="/CompInfo" element={
                <Layout>
                    <CompInfo />
                </Layout>
            } />

            <Route path="/Vision" element={
                <Layout>
                    <Vision />
                </Layout>
            } />
            <Route path="/Location" element={
                <Layout>
                    <Location />
                </Layout>
            } />
            <Route path="/DetailItems" element={
                <Layout>
                    <DetailItems />
                </Layout>
            } />
            <Route path="/FAQ" element={
                <Layout>
                    <FAQ />
                </Layout>
            } />
            <Route path="/Gallery" element={
                <Layout>
                    <Gallery />
                </Layout>
            } />
            <Route path="/News" element={
                <Layout>
                    <News />
                </Layout>
            } />
            <Route path="/Login" element={<Login />} />
            <Route path="/CodeManagement" element={
                <Layout >
                    <CodeManagement />
                </Layout>
            } />
            <Route path="/CEOHistory" element={
                <Layout >
                    <CEOHistory />
                </Layout>
            } />
            <Route path="/Building" element={
                <Layout >
                    <Building />
                </Layout>
            } />

            <Route path="/CultivateHR" element={
                <Layout>
                    <CultivateHR />
                </Layout>
            } />

            <Route path="/Develop" element={
                <Layout >
                    <Develop />
                </Layout>
            } />
            <Route path="/Quality" element={
                <Layout >
                    <Quality />
                </Layout>
            } />
            <Route path="/JobIntroduction" element={
                <Layout >
                    <JobIntroduction />
                </Layout>
            } />
            <Route path="/PersonnelSystem" element={
                <Layout >
                    <Personnel_System />
                </Layout>
            } />
            <Route path="/CultivateHR" element={
                <Layout >
                    <CultivateHR />
                </Layout>
            } />
            <Route path="/ESGManagement" element={
                <Layout >
                    <ESGManagement />
                </Layout>
            } />
            {/* <Route path="/" element={<CodeManagement />} /> */}
        </Routes>

    );
}

export default App;